module.exports = __webpack_public_path__ + "img/skypets-5.8bc8f2c7.jpg";